module.exports = __webpack_public_path__ + "img/pr-4.6e62278c.png";